import { Plus } from "lucide-react";
import { Link } from "react-router-dom";

import { Button } from "@src/shared/components/ui/button";
import { navigationV2 } from "@src/shared/navigation/v2";

import { VisitsListV2 } from "../../../components/v2/VisitsList";

export function VisitsPageV2() {
  return (
    <div className="mx-auto min-h-full w-full max-w-[860px] bg-background px-[18px] pb-8 pt-4">
      <div className="mb-3 flex items-start justify-between gap-3">
        <div className="min-w-0">
          <h1 className="text-[19px] font-semibold leading-tight tracking-[-0.015em] text-surface-foreground">
            Visits
          </h1>
          <p className="mt-1 text-[13px] leading-5 text-muted-foreground">
            Recent visits and the notes generated for each.
          </p>
        </div>
        <Button
          asChild
          size="sm"
          className="h-8 shrink-0 rounded-[9px] px-3 text-[12.5px] font-semibold shadow-none"
        >
          <Link to={navigationV2.home()}>
            <Plus className="size-4" aria-hidden="true" />
            Start a visit
          </Link>
        </Button>
      </div>
      <VisitsListV2 />
    </div>
  );
}
